// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"TableHead_tableHead__r3E9U","columns":"TableHead_columns__29vfu","sticky":"TableHead_sticky__1vHIb","stickyWithMargin":"TableHead_stickyWithMargin__2bmwe"};